var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var DropPop = (function (_super) {
    __extends(DropPop, _super);
    function DropPop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showDropDown = false;
        return _this;
    }
    DropPop.prototype.selectItem = function (item) {
        var _a;
        var items = this.items.map(function (i) { return (__assign({}, i, { selected: i.id == item.id })); });
        this.items.length = 0;
        (_a = this.items).push.apply(_a, items);
        this.showDropDown = false;
        this.$emit('select', item);
    };
    Object.defineProperty(DropPop.prototype, "selectedItem", {
        get: function () {
            var item = this.items.find(function (i) { return i.selected; });
            if (!item) {
                item = {
                    id: '0',
                    label: '',
                    value: '',
                    selected: true,
                };
            }
            return item;
        },
        enumerable: true,
        configurable: true
    });
    DropPop.prototype.mounted = function () {
    };
    __decorate([
        Prop({ type: String })
    ], DropPop.prototype, "label", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], DropPop.prototype, "items", void 0);
    DropPop = __decorate([
        Component({})
    ], DropPop);
    return DropPop;
}(Vue));
export default DropPop;
